import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowCornerLeftDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-corner-left-down"} maskId="square-filled-radius-0-stroke-1-IconArrowCornerLeftDown"><path d="M20 3V4H9.5V19.543L13.5 15.543L14.207 16.25L9 21.457L3.79297 16.25L4.5 15.543L8.5 19.543V3H20Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowCornerLeftDown;
